import { useState, useEffect } from 'react';
import { useMemo } from 'react';

//const isSmall = window.matchMedia('(max-width: 435px)');
const isSmall = window.matchMedia('(max-width: 575px)');
//const isMedium = window.matchMedia('(max-width: 908px)');
//const isLarge = window.matchMedia('(min-width: 1350px)');
const isLarge = window.matchMedia('(min-width: 1200px)');
//const getwsize = (xs, md, lg) => xs ? 0 : md ? 1 : lg ? 3 : 2
const getwsize = (sm, lg) => sm ? 0 : (lg ? 2 : 1)
const sizes = [
	{ //mobile
		xs: { minWidth: "7rem", maxWidth: "50%" },
		sm: { minWidth: "12rem", maxWidth: "100%" },
		md: { minWidth: "17rem", maxWidth: "100%" },
		lg: { minWidth: "100%", maxWidth: "100%" },
		xl: { minWidth: "100%", maxWidth: "100%" },
		full: { minWidth: "100%", maxWidth: "100%" },
	},
	{ //standard
		xs: { minWidth: "8rem", maxWidth: "20%" },
		sm: { minWidth: "13rem", maxWidth: "50%" },
		md: { minWidth: "18rem", maxWidth: "50%" },
		lg: { minWidth: "50%", maxWidth: "100%" },
		xl: { minWidth: "100%", maxWidth: "100%" },
		full: { minWidth: "100%", maxWidth: "100%" },
	},
	{ //large
		xs: { minWidth: "8rem", maxWidth: "15%" },
		sm: { minWidth: "13rem", maxWidth: "20%" },
		md: { minWidth: "20rem", maxWidth: "50%" },
		lg: { minWidth: "50%", maxWidth: "70%" },
		xl: { minWidth: "70%", maxWidth: "100%" },
		full: { minWidth: "100%", maxWidth: "100%" },
	},
]

export const useSizeStyle = (size) => {
	const [wsmall, setwsmall] = useState(isSmall.matches);
	const [wlarge, setwlarge] = useState(isLarge.matches);

	useEffect(() => {
		const smallhandler = e => setwsmall(e.matches)
		const largehandler = e => setwlarge(e.matches)

		isSmall.addEventListener("change", smallhandler);
		isLarge.addEventListener("change", largehandler);

		return () => {
			isSmall.removeEventListener("change", smallhandler)
			isLarge.removeEventListener("change", largehandler)
		}
	}, [])

	const resultStyle = useMemo(() => {
		const idxWidth = getwsize(wsmall, wlarge)

		const actualSize =
			size instanceof Array && size.length === 3
				? size[idxWidth]
				: size instanceof Array && size.length === 1
					? size[0]
					: size

		const sizesStyle = sizes[idxWidth][actualSize]

		if (sizesStyle) return sizesStyle

		if (typeof actualSize === "string" && isNaN(Number(actualSize))) // non numeric string
			return { minWidth: actualSize }

		if (typeof actualSize === "object")
			return actualSize

		const decimalSize = parseFloat(actualSize)

		if (decimalSize <= 1 && decimalSize > 0)
			return { minWidth: `${actualSize * 100}%` }

		if (decimalSize > 1) // not NaN
			return { minWidth: `${actualSize}px` }

		return undefined

	}, [wsmall, wlarge, size]);

	return resultStyle;
}

